import React from "react";
import { Container, Row, Col, Card, ListGroup } from "react-bootstrap";
import { Helmet } from "react-helmet-async";

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | Manav Adhikar Forum</title>
        <meta
          name="description"
          content="Privacy Policy for using the Manav Adhikar Forum website."
        />
        <meta
          name="keywords"
          content="Manav Adhikar Forum, privacy policy, human rights, equality, justice, India, MAF, awareness, campaigns"
        />
        <link
          rel="canonical"
          href="https://manavadhikarforum.in/Privacy-Policy"
        />
      </Helmet>
      <Container className="my-5">
        <Row className="justify-content-center">
          <Col md={10}>
            <Card className="shadow-sm">
              <Card.Header
                as="h1"
                className="text-center bg-primary text-white"
              >
                Privacy Policy
              </Card.Header>
              <Card.Body>
                <p className="lead text-center text-muted fw-medium">
                  Manav Adhikar Forum - A Human Rights NGO
                </p>
                <hr />

                <p>
                  This Privacy Policy outlines how Manav Adhikar Forum (referred
                  to as "we," "us," or "our") collects, uses, and protects your
                  personal information. We are committed to protecting the
                  privacy of our website visitors, members, and supporters.
                </p>

                <h4 className="mt-4">1. Information We Collect</h4>
                <p>
                  We may collect personal information that you voluntarily
                  provide to us when you interact with our website, such as:
                </p>
                <ListGroup variant="flush">
                  <ListGroup.Item>
                    <strong>Contact Information:</strong> Your name, email
                    address, phone number, and mailing address.
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <strong>Donation Information:</strong> Details related to
                    your donations (e.g., amount, date, and payment method),
                    which are processed through secure third-party platforms. We
                    do not store your full credit card information.
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <strong>Engagement Data:</strong> Information about your
                    interaction with our communications (e.g., whether you
                    opened an email or clicked on a link).
                  </ListGroup.Item>
                </ListGroup>

                <h4 className="mt-4">2. How We Use Your Information</h4>
                <p>The information we collect is used to:</p>
                <ListGroup variant="flush">
                  <ListGroup.Item>
                    <strong>Communicate:</strong> Respond to your inquiries,
                    send you updates, and provide information about our human
                    rights initiatives.
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <strong>Process Donations:</strong> Acknowledge and process
                    your generous donations.
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <strong>Improve Our Services:</strong> Analyze user behavior
                    to enhance our website and better serve our mission.
                  </ListGroup.Item>
                </ListGroup>

                <h4 className="mt-4">3. Data Protection</h4>
                <p>
                  We implement appropriate security measures to protect your
                  personal information from unauthorized access, alteration,
                  disclosure, or destruction. We regularly review and update our
                  security practices to ensure your data is safe.
                </p>

                <h4 className="mt-4">4. Third-Party Services</h4>
                <p>
                  We may use trusted third-party services (e.g., payment
                  gateways) to help us operate our website and serve our
                  supporters. These services have their own privacy policies. We
                  do not sell or rent your personal information to third
                  parties.
                </p>

                <h4 className="mt-4">5. Your Rights</h4>
                <p>You have the right to:</p>
                <ListGroup variant="flush">
                  <ListGroup.Item>
                    <strong>Access:</strong> Request a copy of the personal
                    information we hold about you.
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <strong>Correction:</strong> Ask us to correct any
                    inaccurate information.
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <strong>Withdraw Consent:</strong> Opt-out of our
                    communications at any time by contacting us or using the
                    unsubscribe link in our emails.
                  </ListGroup.Item>
                </ListGroup>

                <h4 className="mt-4">6. Changes to This Policy</h4>
                <p>
                  We may update this Privacy Policy from time to time. The
                  revised policy will be posted on this page with the effective
                  date. We encourage you to review this policy periodically.
                </p>

                <h4 className="mt-4">7. Contact Us</h4>
                <p>
                  If you have any questions about this Privacy Policy, please
                  contact us at:
                  <br />
                  Email:{" "}
                  <a href="mailto:manavadhikarforumindia@gmail.com">
                    manavadhikarforumindia@gmail.com
                  </a>
                  <br />
                  Address: 2nd -FR, FL-C-3, Holding No-53, Ramkrishna Garh Road,
                  Manickpur, LP-110/31/10/1, Kolkata, West Bengal-700079
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default PrivacyPolicy;
